import React,{ useEffect, useState } from "react";
import "react-toastify/dist/ReactToastify.css";
import DataTable, { createTheme } from "react-data-table-component";
import { useTheme } from "../../../context/ThemeContext";
import TableLoader from "../../skeletons/TableLoader";
import { checkPermission } from "../../../helpers/GeneralHelper";
import { utcToLocal } from "../../../helpers/DateHelper";
import { getCmsDataTableStyles } from "../../../helpers/DataTableStyles";

export default function MonthlyReportsTable({
    module,
    data,
    loading,
    totalRows,
}) {

    const columns = [
        {
            name: "#",
            selector: (row, index) => index +1 ,
            width: '80px'
        },
        {
            name: <div title="Name">Name</div>,
            selector: (row) => row.user_name,
            width: '200px',
            wrap: true,
            grow: 2, // optional, allows wider columns
            style: {
                whiteSpace: 'normal',
                wordBreak: 'break-word',
            }
        },
        {
            name: <div title="DM">DM</div>,
            selector: (row) => row.manager_name,
            width: '200px',
            wrap: true,
            grow: 2, // optional, allows wider columns
            style: {
                whiteSpace: 'normal',
                wordBreak: 'break-word',
            }
        },
        {
            name: <div title="DOJ">DOJ</div>,
            selector: (row) => row.user_start_date ? row.user_start_date : 'N/A',
            style: {
                whiteSpace: 'normal',
                wordBreak: 'break-word',
                maxWidth: 'none',
            },
            wrap: true,
        },
        {
            name: <div title="Total Positions">Total Positions</div>,
            selector: (row) => row.total_positions ? row.total_positions : 0,
            style: {
                whiteSpace: 'normal',
                wordBreak: 'break-word',
                maxWidth: 'none',
            },
            wrap: true,
        },
        {
            name: <div title="Total Subs">Total Subs</div>,
            selector: (row) => row.total_submissions ? row.total_submissions : 0,
            style: {
                whiteSpace: 'normal',
                wordBreak: 'break-word',
                maxWidth: 'none',
            },
            wrap: true,
        },
        {
            name: <div title="Total Interviews">Total Interviews</div>,
            selector: (row) => row.total_interviews,
            style: {
                whiteSpace: 'normal',
                wordBreak: 'break-word',
                maxWidth: 'none',
            },
            wrap: true,
        },
        {
            name: <div>No Show</div>,
            selector: (row) => row.total_no_shows,
            style: {
                whiteSpace: 'normal',
                wordBreak: 'break-word',
                maxWidth: 'none',
            },
            wrap: true,
        },
        {
            name: <div>Hired</div>,
            selector: (row) => row.total_hired,
            style: {
                whiteSpace: 'normal',
                wordBreak: 'break-word',
                maxWidth: 'none',
            },
            wrap: true,
        },
        {
            name: <div>Started</div>,
            selector: (row) => row.total_started,
            style: {
                whiteSpace: 'normal',
                wordBreak: 'break-word',
                maxWidth: 'none',
            },
            wrap: true,
        },
    ];

    const { theme, toggleTheme } = useTheme();

    createTheme("dark", {
        text: {
            primary: "#a2a3a4",
            secondary: "#2aa198",
        },
        background: {
            default: "#252729",
        },
        context: {
            background: "#cb4b16",
            text: "#a2a3a4",
        },
        divider: {
            default: "#073642",
        },
        action: {
            button: "rgba(0,0,0,.54)",
            hover: "rgba(0,0,0,.08)",
            disabled: "rgba(0,0,0,.12)",
        },
    });

    return (
        <div style={{ overflowX: "auto", width: "100%" }}>
            <div style={{ minWidth: "1600px" }}> {/* 👈 forces the table to be wide enough */}
                <style>
                    {`
                        .rdt_TableHead {
                            z-index: 2 !important; /* stay above body rows */
                        }
                    `}
                </style>
                <DataTable
                    className="clickable cms-data-table"
                    columns={columns}
                    data={data}
                    paginationServer
                    paginationTotalRows={totalRows}
                    progressPending={loading}
                    progressComponent={<TableLoader noOfColumn={columns.length} />}
                    fixedHeader
                    fixedHeaderScrollHeight="75vh"
                    highlightOnHover
                    theme={`${theme === "light" ? "light" : "dark"}`}
                    customStyles={getCmsDataTableStyles(theme)}
                />
            </div>
        </div>
    );
};